var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.items.length > 0)?_c('TrackList',{attrs:{"tracks":_vm.items}}):_vm._e(),_c('InfiniteLoader',{attrs:{"loading":_vm.loading,"has-more":_vm.hasMore},on:{"load-more":_vm.loadMore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }